"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsFields = void 0;
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const form_table_field_1 = require("../../composite/form/fields/form-table-field");
const form_context_1 = require("../../composite/form/form-context");
const selector_1 = require("../../composite/form/selectors/selector");
const internal_settings_columns_1 = require("./internal-settings-columns");
const internal_settings_dialog_1 = require("./internal-settings-dialog");
const useStyles = (0, styles_1.makeStyles)({
    description: {
        fontWeight: 400,
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        padding: '0 16px',
        width: '100%',
        fontSize: 12,
    },
    wrapper: {
        padding: '10px 40px',
    },
});
const SettingsFields = () => {
    const classes = useStyles();
    const settingGroups = (0, selector_1.useFormSelector)((data) => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.settingGroups) !== null && _a !== void 0 ? _a : []; });
    return (react_1.default.createElement("div", { className: classes.wrapper }, (settingGroups !== null && settingGroups !== void 0 ? settingGroups : []).map((group, idx) => (react_1.default.createElement(SettingsGroup, { key: group.name, group: group, idx: idx })))));
};
exports.SettingsFields = SettingsFields;
const SettingsGroup = ({ group, idx, }) => {
    var _a;
    const { editing } = (0, react_1.useContext)(form_context_1.FormContext);
    const classes = useStyles();
    const collectionDatakey = `settingGroups[${idx}].settings`;
    const columns = (0, internal_settings_columns_1.useColumns)(collectionDatakey);
    const MemoizedTable = (0, react_1.useMemo)(() => function Table() {
        return (react_1.default.createElement(form_table_field_1.FormTableField, { name: collectionDatakey, labelOptions: { hide: true }, visibleAdd: false, visibleEdit: editing, layoutOptions: { noSpacing: true }, columns: columns, FormFieldsComponent: internal_settings_dialog_1.InternalSettingsDialog, disabled: false, showRadioCond: ({ canEdit }) => canEdit, visibleRemove: false }));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editing]);
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: group.name, expandable: true, defaultExpanded: false, summary: `[ ${(_a = group === null || group === void 0 ? void 0 : group.settings) === null || _a === void 0 ? void 0 : _a.length} ]` },
        group.description && (react_1.default.createElement("div", { className: classes.description }, group.description)),
        react_1.default.createElement(MemoizedTable, null)));
};
//# sourceMappingURL=internal-settings-fields.js.map